<template>
    <div class="container">
        <maijia-head></maijia-head>
        <p>{{title}}</p>
        <div class="content" v-html="content"></div>
    </div>
</template>

<script>
import maijiaHead from '../components/maijia-head.vue'

export default {
    data() {
        return {
            title: '',
            content: '',
        }
    },
    components: {
        maijiaHead
    },
    computed: {
        lang() {
            return this.$i18n.locale
        }
    },
    watch: {
        'lang'() {
            const { getData } = this
            getData()
        }
    },
    created() {
        const { getData } = this
        getData()
    },
    methods: {
        getData() {
            this.$http.get("site/news-detail", {
                params: {
                    NewsID: this.$route.query.NewsID,
                    lang: this.$i18n.locale
                }
            }).then(response => {
                this.content = response.d["Content"];
                this.title = response.d["Title"];
            });
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    & /deep/ .maijia_head {
        background-color: #000;
    }
    & > p {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        color: #333333;
    }
    & .content {
        padding: 0 16px;
        & /deep/ img {
            width: 100%;
            display: block;
        }
        & /deep/ p {
            font-size: 14px;
            color: #000000;
            line-height: 24px;
        }
    }
}
</style>